import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (only in production builds).
// We auto-activate updates and reload once so users never get stuck on a stale bundle.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((reg) => {
      const promote = (w) => {
        if (!w) return;
        w.addEventListener('statechange', () => {
          if (w.state === 'installed' && navigator.serviceWorker.controller) {
            // A new version has installed alongside the old one — activate it now.
            w.postMessage('SKIP_WAITING');
          }
        });
      };
      promote(reg.waiting);
      reg.addEventListener('updatefound', () => promote(reg.installing));
    }).catch(() => null);

    // When the active SW changes, reload the page once to pick up the fresh bundle.
    let refreshed = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshed) return;
      refreshed = true;
      window.location.reload();
    });
  });
}
